import map from 'lodash/map'
import React from 'react'
import { useContext } from './Context'
import { BlogBox } from '@ztechapps/blog.webui'
import { routesDef } from '../../../config/routes'
import { LoadMoreButton } from '@ztechapps/webui.button'
import type { Blog } from '@ztechapps/common.contract'
import { EmptyUseAndCare } from '../EmptyUseAndCare'
import PageTitle from '../../../components/PageTitle'
export const Layout = () => {
  const { list, pageInfo, loadMoreEntries, loading, sort, filter, isEmpty } = useContext()

  if (isEmpty) {
    return <EmptyUseAndCare />
  }

  return (
    <div>
      <PageTitle
        title="Use and Care Guides - List"
        description="Learn how to properly use and care for your PanelPunches products with our comprehensive guides."
      />
      <div className="row ">
        {map(list, (blog: Blog) => (
          <div key={blog?._id} className="col-md-4">
            <BlogBox
              title={blog.title}
              summary={blog.summary}
              updatedAt={blog.updatedAt}
              status={blog.status}
              tags={blog.tags}
              cover={blog.cover}
              linkToPath={routesDef.UseAndCareItemPage.altPath(blog._id)}
            />
          </div>
        ))}
      </div>

      <LoadMoreButton
        {...{
          bsStyle: 'primary',
          dataArray: list,
          pageInfo,
          loadMoreEntries,
          loading,
          sort,
          filter,
        }}
      />
    </div>
  )
}
